import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { SERVER_URL } from '../../../../../Config/config';
import { toast } from 'react-hot-toast';
import { disable2FA } from './AdminAddSlice';

export const login = createAsyncThunk('auth/login', async ({ email, password, totpToken,otp }, { rejectWithValue }) => {
  try {
    const response = await axios.post(
      `${SERVER_URL}/api/v1/adminAuth/login`,
      { email, password, totpToken , otp},
      { withCredentials: true }
    );
    console.log("login",response.data);
    return response.data;
  } catch (err) {
    const errorMessage = err.response?.data?.error || 'Login failed';
    toast.error(errorMessage);
    return rejectWithValue(errorMessage);
  }
});

export const setup2FA = createAsyncThunk('auth/setup2FA', async (_, { rejectWithValue }) => {
  try {
    const response = await axios.post(
      `${SERVER_URL}/api/v1/adminAuth/2fa/setup`,
      {},
      { withCredentials: true, headers: { Authorization: `Bearer ${sessionStorage.getItem('accessToken')}` } }
    );
    return response.data;
  } catch (err) {
    const errorMessage = err.response?.data?.error || '2FA setup failed';
    toast.error(errorMessage);
    return rejectWithValue(errorMessage);
  }
});

export const verify2FA = createAsyncThunk('auth/verify2FA', async (token, { rejectWithValue }) => {
  try {
    const response = await axios.post(
      `${SERVER_URL}/api/v1/adminAuth/2fa/verify`,
      { token },
      { withCredentials: true, headers: { Authorization: `Bearer ${sessionStorage.getItem('accessToken')}` } }
    );
    return response.data;
  } catch (err) {
    const errorMessage = err.response?.data?.error || '2FA verification failed';
    toast.error(errorMessage);
    return rejectWithValue(errorMessage);
  }
});


const adminAuthSlice = createSlice({
  name: 'adminAuth',
  initialState: {
    user: null,
    accessToken: sessionStorage.getItem('accessToken') || null,
    refreshToken: null,
    isAuthenticated: !!sessionStorage.getItem('accessToken'),
    loading: false,
    error: null,
    twoFactorSetup: null,
  },
  reducers: {
    logout: (state) => {
      state.user = null;
      state.accessToken = null;
      state.refreshToken = null;
      state.isAuthenticated = false;
      state.twoFactorSetup = null;
      sessionStorage.removeItem('accessToken');
      toast.success('Logged out successfully');
    },
    clear2FASetup: (state) => {
      state.twoFactorSetup = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(login.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(login.fulfilled, (state, action) => {
        state.loading = false;
        state.user = action.payload.user;
        state.accessToken = action.payload.accessToken;
        state.refreshToken = action.payload.refreshToken;
        state.isAuthenticated = true;
        sessionStorage.setItem('accessToken', action.payload.accessToken);
        toast.success('Logged in successfully');
      })
      .addCase(login.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(setup2FA.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(setup2FA.fulfilled, (state, action) => {
        state.loading = false;
        state.twoFactorSetup = action.payload;
      })
      .addCase(setup2FA.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(verify2FA.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(verify2FA.fulfilled, (state, action) => {
        state.loading = false;
        state.twoFactorSetup = null;
        console.log('verify2FA fulfilled, payload:', action.payload);
        console.log('Current user state before update:', state.user);
      const userData = action.payload.verified;
        if (userData && Object.keys(userData).length > 0) {
          state.user = {
            ...state.user,
            ...userData,
            twoFactorEnabled: userData.twoFactorEnabled ?? true,
          };
          toast.success('2FA enabled successfully');
        } else {
          console.error('verify2FA: Invalid or empty user data in payload:', userData);
          toast.error('Failed to update 2FA status');
        }

      })
      .addCase(verify2FA.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(disable2FA.fulfilled, (state, action) => {
        if (action.payload.admin && state.user) {
          state.user = {
            ...state.user,
            twoFactorEnabled: false,
          };
          toast.success('2FA disabled successfully');
        }
      });
  },
});

export const { logout, clear2FASetup } = adminAuthSlice.actions;
export default adminAuthSlice.reducer;